import translate from '@translate';
import React, { FC, useEffect, useState } from 'react';
import Select, { OnChangeType, SelectValueType } from 'src/components/Select';
import { RootStoreType } from 'src/types/store';
import { useDispatch, useSelector } from 'react-redux';
import { getDpdCountriesFetch, getDpdPlacesFetch } from 'src/resources/dpdPlaces/reducer';
import Grid, { GridItem } from '../Grid';

export interface DdpSelectPropsType {
    onChange: OnChangeType;
    value: SelectValueType;
    error?: boolean;
    name?: string;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    fullWidth?: boolean;
}

const DdpSelect: FC<DdpSelectPropsType> = (props) => {
    const dispatch = useDispatch();

    const [country, setCountry] = useState<string>('');

    const data = useSelector((state: RootStoreType) => state.dpdPlaces.data);
    const dataCountries = useSelector((state: RootStoreType) => state.dpdPlaces.dataCountries);
    const loading = useSelector((state: RootStoreType) => state.dpdPlaces.loading);

    useEffect(() => {
        if (!dataCountries) {
            dispatch(getDpdCountriesFetch());
        }
    }, [dataCountries]);

    useEffect(() => {
        if (country) {
            dispatch(getDpdPlacesFetch(country));
        }
    }, [country]);

    useEffect(() => {
        if (!country && props.value && dataCountries) {
            const countryChar = String(props.value).slice(0, 2).toLowerCase();
            const countryItem = dataCountries.find((item: any): any => item.iso === countryChar);
            if (countryItem) {
                handleChangeCountry(countryItem.value);
            }
        }
    }, [props.value, dataCountries]);

    const handleChangeCountry = (value: any) => {
        if (country !== value) {
            setCountry(String(value));
            if (country) {
                props.onChange(null, true);
            }
        }
    };

    const options = data || [];

    const isSet = !props.value || options?.filter((option: any): boolean => option.value === props.value).length;
    const allOptions = isSet
        ? options
        : [{ label: `${translate('messages.branchUnavailable')} (${props.value})`, value: props.value }, ...options];
    return (
        <Grid>
            <GridItem cols={4}>
                <Select
                    options={dataCountries || []}
                    value={country}
                    error={props.error}
                    onChange={handleChangeCountry}
                    name={`${props.name}country`}
                    label={translate('orderDetail.countryOfDelivery')}
                    required={props.required}
                    disabled={props.disabled}
                    fullWidth={props.fullWidth}
                    loading={loading}
                />
            </GridItem>
            {!!country && (
                <GridItem cols={8}>
                    <Select
                        options={allOptions}
                        value={props.value}
                        error={props.error}
                        onChange={props.onChange}
                        name={props.name}
                        label={props.label}
                        required={props.required}
                        disabled={props.disabled}
                        fullWidth={props.fullWidth}
                        loading={loading}
                        virtualized
                    />
                </GridItem>
            )}
        </Grid>
    );
};

export default DdpSelect;
